import styled from "styled-components";

export const color = ({ type, theme }) => {
  switch (type) {
    case "info":
      return theme.colors.neutral.gray4;
    case "warning":
      return theme.colors.feedbackState.warning.default;
    case "success":
      return theme.colors.feedbackState.success.default;

    default:
      return theme.colors.feedbackState.critical.default;
  }
};

const fontSize = ({ size }) => {
  switch (size) {
    case "xs":
      return "12px";
    case "sm":
      return "14px";
    case "lg":
      return "20px";

    case "md":
    default:
      return "16px";
  }
};

export const Text = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;

  color: ${color};

  svg {
    fill: ${color};
  }

  p {
    font-size: ${fontSize};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    line-height: 16px;
    letter-spacing: 0.02em;
    text-align: left;
    height: 12px;
  }
`;
